'use strict';

const $ = window.jQuery;

module.exports = function () {
	// custom scrollbars, adjust styles here
    $('.scroll-section').niceScroll({
        cursorcolor: '#df4d4f',
        cursorborder: '0',
        cursorborderradius: '0',
        cursorwidth: '5px',
    });
}
